import { Link } from "react-router-dom";

const STEPS = [
  {
    n: "01",
    title: "Register, Free & Easy",
    body: "Create a free Agrovest account on the ARTS Registration Portal. Complete your profile and upload a 2-minute 'Why I Should Be Nigeria's Next Agric Champion' video. Open to all Nigerian citizens aged 18–35.",
    cta: { label: "Register Now, It's Free", to: "/register" },
  },
  {
    n: "02",
    title: "Audition, State-Level & Online",
    body: "Shortlisted applicants attend state-level physical auditions or submit online video auditions. Evaluated by agricultural scientists, agribusiness leaders, media professionals, and Governor Bago.",
    cta: { label: "Check Your State Audition Date", to: "/apply" },
  },
  {
    n: "03",
    title: "Selected, 37 Champions Chosen",
    body: "37 exceptional young Nigerians selected. Selection results announced live on Global TV and across Agrovest digital platforms.",
    cta: { label: "View Selected Contestants", to: "/contestants" },
  },
  {
    n: "04",
    title: "60-Day Live Competition at the Farm Hub",
    body: "Contestants live at the Agrovest Farm Hub for 60 days. 13 broadcast episodes. Challenges in crop production, livestock management, agro-processing, agribusiness pitching, market competitions, technology innovation, and community impact.",
    cta: { label: "See the Episode Guide", to: "/episodes" },
  },
  {
    n: "05",
    title: "Win, Grow & Join 37,000 Alumni",
    body: "Top contestants receive life-changing rewards. All 37,000 beneficiaries across the 37 states join the Agrovest Alumni Network with lifetime training, finance, market linkages, and mentorship.",
    cta: { label: "View Prizes & Benefits", to: "/about" },
  },
];

const AUDITION = [
  ["North-West", "Sokoto, Kano, Kaduna, Kebbi, Zamfara, Katsina, Jigawa", "May 1–5, 2026"],
  ["North-East", "Bauchi, Gombe, Borno, Adamawa, Yobe, Taraba", "May 6–10, 2026"],
  ["North-Central", "Abuja FCT, Niger, Kogi, Plateau, Nasarawa, Kwara, Benue", "May 12–16, 2026"],
  ["South-West", "Lagos, Ogun, Oyo, Osun, Ondo, Ekiti", "May 18–22, 2026"],
  ["South-East", "Enugu, Anambra, Imo, Ebonyi, Abia", "May 24–28, 2026"],
  ["South-South", "Rivers, Delta, Cross River, Edo, Bayelsa, Akwa Ibom", "May 29–31, 2026"],
];

export default function HowItWorks() {
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-12 py-24">
      <div className="text-xs uppercase tracking-[0.3em] text-[#F26A1F] mb-5">
        Five steps to your shot
      </div>
      <h1
        className="text-5xl md:text-7xl font-black tracking-tighter leading-[0.95]"
        style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
      >
        Your state.<br />
        Your shot.<br />
        <span className="text-[#F26A1F]">Show the money.</span>
      </h1>

      <div className="mt-16 space-y-6">
        {STEPS.map((s, i) => (
          <div
            key={s.n}
            className={`p-8 md:p-12 border border-white/10 hover:border-[#1E8E3E]/60 transition-colors ${
              i % 2 === 0 ? "" : "md:ml-12"
            }`}
          >
            <div className="grid md:grid-cols-12 gap-8 items-start">
              <div className="md:col-span-3">
                <div className="text-xs uppercase tracking-[0.3em] text-[#1E8E3E] font-bold mb-2">
                  Step
                </div>
                <div
                  className="text-6xl md:text-7xl font-black text-[#F26A1F] tracking-tighter"
                  style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
                >
                  {s.n}
                </div>
              </div>
              <div className="md:col-span-9">
                <h2
                  className="text-2xl md:text-3xl font-bold tracking-tight mb-4"
                  style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
                >
                  {s.title}
                </h2>
                <p className="text-white/70 leading-relaxed">{s.body}</p>
                <Link
                  to={s.cta.to}
                  className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-[#F26A1F] hover:text-white transition-colors"
                >
                  {s.cta.label} →
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      <section className="mt-24">
        <h2
          className="text-3xl md:text-4xl font-bold tracking-tighter mb-8"
          style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
        >
          State audition schedule
        </h2>
        <div className="border border-white/10 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-white/[0.03] text-xs uppercase tracking-[0.2em] text-[#F26A1F]">
              <tr>
                <th className="text-left p-4">Zone</th>
                <th className="text-left p-4">States</th>
                <th className="text-left p-4">Dates</th>
                <th className="text-left p-4">Format</th>
              </tr>
            </thead>
            <tbody>
              {AUDITION.map(([zone, states, date]) => (
                <tr key={zone} className="border-t border-white/5">
                  <td className="p-4 font-bold">{zone}</td>
                  <td className="p-4 text-white/70">{states}</td>
                  <td className="p-4 text-[#2BA84A] font-bold">{date}</td>
                  <td className="p-4 text-white/70">Physical + Online</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
